import {
  ApplicationConfig,
  isDevMode,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import {
  provideRouter,
  withComponentInputBinding,
  withViewTransitions,
} from '@angular/router';

import {
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { getBrowserLang, provideTransloco } from '@jsverse/transloco';
import { apimInterceptor } from './auth/setup/apim-interceptor';
import { authInitializer } from './auth/setup/auth-initilizer';
import { AUTH_PROVIDER } from './auth/setup/auth.provider';
import { routes } from './routing/app.routes';
import { TranslocoHttpLoader } from './transloco-loader';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withViewTransitions(), withComponentInputBinding()),
    provideHttpClient(
      withInterceptorsFromDi(),
      withInterceptors([apimInterceptor]),
    ),
    provideAnimations(),
    provideTransloco({
      config: {
        availableLangs: ['en', 'de'],
        defaultLang: getBrowserLang(),
        fallbackLang: ['en'],
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
        missingHandler: {
          useFallbackTranslation: true,
        },
      },
      loader: TranslocoHttpLoader,
    }),
    provideAppInitializer(authInitializer()),
    AUTH_PROVIDER(),
  ],
};
